import React, { Fragment, useEffect, useState } from 'react';
import { useUIMode } from "../hooks/useUIMode";
import { useTranslation } from 'react-i18next';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView    from "./TemplateListView";
import AccessPointAdminDetailsView from "./AccessPointAdminDetailsView";
import AccessPointAdminNewView     from "./AccessPointAdminNewView";


const AccessPointAdmin = () => {

  const { t }    = useTranslation(["common"]);
  //const { user } = useContext(UserContext);
  //const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "AccessPointAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

/*
  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["???Access"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
*/


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'code',
      name: t("I18N_Code"),
      sortable: true,
      sortField: 'code',
      grow: 1,
      cell: null
    },
    {
      name: t("I18N_Name"),
      selector: row => row.name,
      sortable: true,
      sortField: 'name',
      grow: 1.5,
      wrap: true
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2.5,
      wrap: true
    },
    {
      name: t("I18N_Type"),
      selector: row => t("I18N_" + row.type),
      sortable: true,
      sortField: 'type'
    },
    {
      name: <div style={{ whiteSpace: 'normal' }}>{t("I18N_Protection_type")}</div>,
      selector: row => t("I18N_" + row.protType),
      sortable: true,
      sortField: 'protType'
    },
    {
      name: t("I18N_Location"),
      selector: row => row.location,
      cell: row => row.location,
      sortable: true,
      sortField: 'location',
      grow: 2
    },
    {
      name: t("I18N_Status"),
      selector: row => t("I18N_ST_" + row.status),
      sortable: true,
      sortField: 'status',
      grow: 0.5
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API}
                                                  apiObjName={'access-points'}
                                                  listPageTitle={t("I18N_AccessPoint_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_Access_point")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_AccessPoint_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_Access_point")}
                                                  tableColumns={tableColumns}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState} onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <AccessPointAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <AccessPointAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default AccessPointAdmin;
